/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { RouteComponent } from "vue-router";
import type { LastLevelRouteKey, RouteLayout } from "@elegant-router/types";

import BaseLayout from "@/layouts/base-layout/index.vue";
import BlankLayout from "@/layouts/blank-layout/index.vue";

export const layouts: Record<RouteLayout, RouteComponent | (() => Promise<RouteComponent>)> = {
  base: BaseLayout,
  blank: BlankLayout,
};

export const views: Record<LastLevelRouteKey, RouteComponent | (() => Promise<RouteComponent>)> = {
  403: () => import("@/views/_builtin/403/index.vue"),
  404: () => import("@/views/_builtin/404/index.vue"),
  500: () => import("@/views/_builtin/500/index.vue"),
  "iframe-page": () => import("@/views/_builtin/iframe-page/[url].vue"),
  login: () => import("@/views/_builtin/login/index.vue"),
  about_daxing: () => import("@/views/about/daxing/index.vue"),
  about_video: () => import("@/views/about/video/index.vue"),
  advertising_amanage: () => import("@/views/advertising/amanage/index.vue"),
  advertising_gmanage: () => import("@/views/advertising/gmanage/index.vue"),
  aiknowledge: () => import("@/views/aiknowledge/index.vue"),
  aiknowledgenew_chat: () => import("@/views/aiknowledgenew/chat/index.vue"),
  aiknowledgenew_doc: () => import("@/views/aiknowledgenew/doc/index.vue"),
  aiknowledgenew_index: () => import("@/views/aiknowledgenew/index/index.vue"),
  aitraining: () => import("@/views/aitraining/index.vue"),
  company: () => import("@/views/company/index.vue"),
  home: () => import("@/views/home/index.vue"),
  invest: () => import("@/views/invest/index.vue"),
  "investment-operation-data": () => import("@/views/investment-operation-data/index.vue"),
  "investment-operation": () => import("@/views/investment-operation/index.vue"),
  "manage_cache-list": () => import("@/views/manage/cache-list/index.vue"),
  "manage_cache-monitor": () => import("@/views/manage/cache-monitor/index.vue"),
  manage_config: () => import("@/views/manage/config/index.vue"),
  manage_dept: () => import("@/views/manage/dept/index.vue"),
  manage_dict: () => import("@/views/manage/dict/index.vue"),
  "manage_file-manage": () => import("@/views/manage/file-manage/index.vue"),
  "manage_login-log": () => import("@/views/manage/login-log/index.vue"),
  manage_menu: () => import("@/views/manage/menu/index.vue"),
  "manage_operation-log": () => import("@/views/manage/operation-log/index.vue"),
  "manage_oss-config": () => import("@/views/manage/oss-config/index.vue"),
  manage_post: () => import("@/views/manage/post/index.vue"),
  manage_role: () => import("@/views/manage/role/index.vue"),
  "manage_system-monitor": () => import("@/views/manage/system-monitor/index.vue"),
  "manage_user-detail": () => import("@/views/manage/user-detail/[id].vue"),
  manage_user: () => import("@/views/manage/user/index.vue"),
  parkmanage: () => import("@/views/parkmanage/index.vue"),
  policy: () => import("@/views/policy/index.vue"),
  product: () => import("@/views/product/index.vue"),
  project: () => import("@/views/project/index.vue"),
  projectcatalog: () => import("@/views/projectcatalog/index.vue"),
  retained_appeal: () => import("@/views/retained/appeal/index.vue"),
  retained_entry: () => import("@/views/retained/entry/index.vue"),
  retained_purpose: () => import("@/views/retained/purpose/index.vue"),
  retained_report: () => import("@/views/retained/report/index.vue"),
  "user-center": () => import("@/views/user-center/index.vue"),
};
